module.exports = __webpack_public_path__ + "img/nlic_gallery2.a20d8164.jpg";